import axios from 'axios';
import { auth } from '../firebase';

// The backend comes only from the build's environment (the staging or production
// GitHub environment sets REACT_APP_BACKEND_URL). There is no default, so a build
// or a local run without it fails instead of quietly talking to the prod backend.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
if (!BACKEND_URL) {
  throw new Error('REACT_APP_BACKEND_URL is not set: point it at the staging or local backend.');
}

const client = axios.create({ baseURL: BACKEND_URL });

// Every request carries the signed-in nurse's Firebase ID token. getIdToken()
// returns the cached token and refreshes it automatically when it's near expiry.
client.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let handleUnauthenticated = () => {};

// AuthContext registers a handler so a 401 from any call signs the nurse out.
export function setUnauthenticatedHandler(handler) {
  handleUnauthenticated = handler;
}

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      handleUnauthenticated();
    }
    return Promise.reject(error);
  }
);

// Backend errors come back as { error: "<code>" }.
export function errorCode(error) {
  if (!error?.response) return 'network_error';
  return error.response.data?.error || 'server_error';
}

export default client;
